import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

export interface TimelineItem {
  key: string;
  title: string;
  detail?: ReactNode;
  meta?: ReactNode;
}

export interface TimelineProps {
  items: readonly TimelineItem[];
  className?: string;
}

/**
 * An ordered list of things that happened, or are meant to happen (plan §2.6). The rail is a border on
 * the start edge, so it mirrors with the document direction without a single directional utility.
 */
export const Timeline = ({ items, className }: TimelineProps) => (
  <ol className={cn('space-y-4 border-s border-border ps-4', className)}>
    {items.map((item) => (
      <li
        key={item.key}
        className="relative"
      >
        <span className="absolute -start-[21px] top-1.5 size-2 rounded-full bg-primary" />
        <p className="text-sm font-medium text-foreground">{item.title}</p>
        {item.detail ? <p className="mt-0.5 text-sm text-muted-foreground">{item.detail}</p> : null}
        {item.meta ? <p className="mt-0.5 text-xs text-muted-foreground">{item.meta}</p> : null}
      </li>
    ))}
  </ol>
);
